import "azure-devops-ui/CommonImports";
import "azure-devops-ui/Core/core.css";
import "./Ansi.css";
import "./LogViewer.css";
import * as React from "react";
import { Icon } from "azure-devops-ui/Icon";
import { NodeType } from "../../Utilities/LogParser.Types";
import { getType } from "../../Utilities/Parser";
// note: we have a test case in AnsiParser.test.ts that tests for XSS
/* tslint:disable:react-no-dangerous-html*/
const HTMLContent = (props) => {
    return (React.createElement("span", { dangerouslySetInnerHTML: {
            __html: props.data
        } }));
};
export class LineTransform extends React.Component {
    render() {
        const props = this.props;
        /* tslint:disable */
        return (React.createElement(React.Fragment, null, props.line.nodes.map((x) => {
            const text = (props.raw || "").substring(x.start, x.end + 1);
            const content = props.subParser.parse(text, props.lineNumber, props.findResult, props.pureHTML, props.contentId);
            switch (x.type) {
                case NodeType.Icon:
                    return (React.createElement("span", { key: x.index },
                        React.createElement(Icon, { iconName: text.trim(), className: "line-icon" })));
                case NodeType.Group:
                    return (React.createElement("span", { key: x.index },
                        React.createElement("span", { className: "group-expand" },
                            React.createElement(Icon, { iconName: `TriangleSolidRight12 ${props.expanded ? "rotate" : ""}`, className: "group-icon", role: "button", ariaExpanded: !!props.expanded, ariaLabel: !!props.expanded ? "collapse" : "expand" }),
                            React.createElement(HTMLContent, { data: content }))));
                default:
                    return (React.createElement("span", { key: x.index, className: `pl-${getType(x)}` },
                        React.createElement(HTMLContent, { data: content })));
            }
        })));
        /* tslint:enable */
    }
}
